// Get the form values
const form = document.querySelector('.custom-form form');

// === META HELPERS ===
const submitBtn = form?.querySelector('button[type="submit"], .club-form__button');
const metaEventId = uuidv4(); // un ID unique par soumission
if (submitBtn) {
  submitBtn.addEventListener('click', () => {
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'ProFormCTA', {}, { eventID: metaEventId });
    }
  });
}

// Style for form
let requiredInputs = form.querySelectorAll('input[required]');

requiredInputs.forEach(input => {
  // Add red asterisk to placeholder text if not already present
  if (!input.placeholder.endsWith(' *')) {
    input.placeholder = input.placeholder + ' *';
  }
});


// For checkboxes group : check a fake required input to trigger native form error when no checkbox is checked
toggleRequiredInput('interest');


form.addEventListener('submit', async (e) => {
  e.preventDefault();
  document.querySelector('.club-form__button .loader-container').classList.remove('is-hide');
  sendData(form);
});

/* FUNCTIONS */

// InputNameAttr is interest for example
function toggleRequiredInput(inputNameAttr){
  let checkboxes = document.querySelectorAll(`input[name="${inputNameAttr}"]:not(.club-form__input--validator)`);
  let requiredInput = document.querySelector(`input.club-form__input--validator[name="${inputNameAttr}"]`);

  // Initialize the validator checkbox state
  requiredInput.checked = Array.from(checkboxes).some(checkbox => checkbox.checked);

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      // Update the validator checkbox based on whether any real checkboxes are checked
      const hasCheckedBoxes = Array.from(checkboxes).some(checkbox => checkbox.checked);
      requiredInput.checked = hasCheckedBoxes;
      
      // Trigger validation on the validator input
      requiredInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

function getLanguage() {
  const url = window.location.href.toLowerCase();
  let lang = 'en'; // default

  if (url.includes('/nl')) {
    lang = 'nl';
  } else if (url.includes('/fr')) {
    lang = 'fr';
  }

  console.log(lang);
  return lang;
}

function getFormData() {
    const formData = new FormData(form);
    let formDataObject = Object.fromEntries(formData.entries());

    // Get the tags from the checkbox group and filter out empty values and validator value
    const tags = formData.getAll('interest').filter(tag => tag !== '' && tag !== 'validator');
    const language = getLanguage();

    // Create the new form data object (sent to Odoo)
    const newFormData = {
      "contact": {
        "name": formDataObject.firstname + " " + formDataObject.lastname,
        "email": formDataObject.email,
        "phone": formDataObject.phone,
        "country": formDataObject.country || '',
        "role": formDataObject.user_type,
        "lang": language || 'en'
      },
      "company": {
        "companyName": formDataObject.clubsname,
        "country": formDataObject.country
      },
      "opportunity": {
        "interests": tags,
        "nb_members": parseInt(formDataObject.nbmembers),
        "message": formDataObject.message
      },
      "metadata": {
        "source": window.location.href,
        "date": new Date().toISOString().slice(0,10).replace(/-/g,'-'),
        "meta_event_id": metaEventId,
        "_fbp": getFbp(),
        "_fbc": getFbc(),
      }
    }

    return newFormData;
}

function sendData() {
  const formData = getFormData();


  const submitBtn = document.querySelector('.club-form__button');
  submitBtn.disabled = true;
  submitBtn.classList.add('loading');
  submitBtn.querySelector('.loader-container').classList.remove('is-hide');

  window.BounceApi.post('/odoo/create-b2b-lead', formData)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    document.querySelector('.custom-form__info-message--success-message').classList.add('show');
    document.querySelector('.club-form__button .loader-container').classList.add('is-hide');
    submitBtn.disabled = false;
    submitBtn.classList.remove('loading');
    // Reset the form after successful submission
    if (form) {
      form.reset();
    }

    // Handle success - maybe clear form or show success message
    // === META HELPERS ===
    // 🔔 Pixel Meta en fire-and-forget, ne touche pas à l'UI. Success côté serveur → on envoie aussi côté navigateur avec le même eventID
    try {
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', { content_name: 'Bounce Pro Club Form' }, { eventID: payload.metadata.meta_event_id });
      }
    } catch (e) {
      // On loggue éventuellement mais on ne modifie PAS l'UI
      console.warn('fbq Lead failed:', e);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    document.querySelector('.custom-form__info-message--error-message').classList.add('show');
    submitBtn.disabled = false;
    submitBtn.classList.remove('loading');
    document.querySelector('.club-form__button .loader-container').classList.add('is-hide');
    // Handle error - show error message to user
  });

}

// === META HELPERS ===
function uuidv4(){
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c){
    const r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}
function getCookie(name){
  const m = document.cookie.match('(?:^|; )'+name.replace(/([.$?*|{}()[\]\\/+^])/g,'\\$1')+'=([^;]*)');
  return m ? decodeURIComponent(m[1]) : '';
}
function getFbp(){ return getCookie('_fbp'); }
function getFbc(){ return getCookie('_fbc'); } // présent si fbclid dans l’URL
